<script>
  import {tipProps} from './index.js'
  export default {
    name: 'sy-static-area',
    props: tipProps,
    data () {
      return {}
    },
    methods: {
      handleCloseTip () {
        if (this.customClose) {
          this.customClose()
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    render () {
      const {$slots, $scopedSlots, type, hasClose, visible} = this
      console.log('this', $slots, $scopedSlots)
      return (
        visible &&
        <div
          class={[
            'sy-static-area',
            'static-area-' + type,
            {
              'static-area-has-close': hasClose
            }
          ]}
        >
          <div class="static-area-content-wrap">
            {
              hasClose
                ? <i class="static-area-close el-icon-close" on-click={this.handleCloseTip}/>
                : null
            }
            {
              type !== 'text'
                ? (<i
                  class="iconfont title-icon"
                >
                  {
                    (type === 'warning' || type === 'warningBackGround')
                      ? [<span>&#xe82d;</span>]
                      : [<span>&#xe82f;</span>]
                  }
                </i>)
                : null
            }
            <div class="static-area-title">{$slots.title || ($scopedSlots.title && $scopedSlots.title())}</div>
            <div class="static-area-content">
              {$slots.longText || ($scopedSlots.longText && $scopedSlots.longText())}
            </div>
          </div>
        </div>
      )
    }
  }
</script>

<style lang="scss" scoped>
.sy-static-area {
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  .static-area-content-wrap {
    position: relative;
    padding-left: 24px;
    padding-right: 16px;
    .title-icon {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 16px;
      z-index: 1;
      line-height: 16px;
    }
    .static-area-close {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 16px;
      cursor: pointer;
      z-index: 1;
      line-height: 16px;
    }
  }
  .static-area-title {
    margin-bottom: 8px;
    line-height: 22px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .static-area-content {
    padding-right: 8px;
  }
}
.static-area-has-close {
  padding-right: 24px;
}
// text: 文本提示、warning: 警告提示（无底色）、warningBackGround: 警告提示（含底色）、error: 错误提示（无底色）、errorBackGround: 错误提示（含底色）
.static-area-text {}
.static-area-warning {
  .title-icon, .static-area-close {
    color: #E6A23C;
  }
}
.static-area-warningBackGround {
  background: #FDF6EC;
  border: 1px #F5E2C6 solid;
  padding: 16px 24px;
  .title-icon, .static-area-close {
    color: #E6A23C;
  }
}
.static-area-error {
  .title-icon, .static-area-close {
    color: #DF4424;
  }
}
.static-area-errorBackGround {
  background: #FEF0F0;
  border: 1px #F6D7D7 solid;
  padding: 16px 24px;
  .title-icon, .static-area-close {
    color: #DF4424;
  }
}
</style>
